import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EmptyStateWithNextAction } from '@cedarreachai/ui';
import { FailureNotice } from '@/components/FailureNotice';
import { presentFailure } from '@/lib/api/failure';

/**
 * Route-level error element.
 *
 * A loader that fails is the same class of event as a query that fails, so it
 * gets the same retriable/terminal vocabulary rather than a second one.
 */
export function RouteError() {
  const error = useRouteError();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const failure = presentFailure(error);
  if (failure) {
    return (
      <FailureNotice
        failure={failure}
        onRetry={() => navigate(0)}
        resolveAction={
          failure.kind === 'terminal'
            ? { label: t('common.reload'), onClick: () => navigate(0) }
            : undefined
        }
      />
    );
  }

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <EmptyStateWithNextAction
        title={t('errors.notFoundTitle')}
        description={t('errors.notFoundBody')}
        action={{ label: t('placeholder.action'), onClick: () => navigate('..') }}
      />
    );
  }

  return (
    <EmptyStateWithNextAction
      title={t('errors.title')}
      description={error instanceof Error ? error.message : t('errors.boundaryBody')}
      action={{ label: t('common.reload'), onClick: () => navigate(0) }}
    />
  );
}
